((Drupal) => {
  Drupal.theme.message = ({ text }, { type, id }) => {
    const labels = {
      status: Drupal.t('Status message'),
      warning: Drupal.t('Warning message'),
      error: Drupal.t('Error message'),
    };
    const label = labels[type] || '';

    const wrapper = document.createElement('div');
    wrapper.className = `messages messages--${type}`;
    wrapper.setAttribute('data-message-type', type);
    wrapper.setAttribute('data-drupal-message-id', id);
    wrapper.setAttribute('role', 'contentinfo');
    wrapper.setAttribute('aria-label', label);

    const inner = document.createElement('div');
    inner.className = 'messages__inner';
    if (type === 'error') {
      inner.setAttribute('role', 'alert');
    }

    const icon = document.createElement('div');
    icon.className = 'messages__icon';
    icon.setAttribute('aria-hidden', 'true');

    const content = document.createElement('div');
    content.className = 'messages__content';

    const heading = document.createElement('h2');
    heading.className = 'visually-hidden';
    heading.textContent = label;

    const message = document.createElement('p');
    message.className = 'messages__message';
    message.innerHTML = text;

    content.appendChild(heading);
    content.appendChild(message);
    inner.appendChild(icon);
    inner.appendChild(content);
    wrapper.appendChild(inner);

    return wrapper;
  };
})(Drupal);
